import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=2327ff34&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"
import style0 from "./Preference.vue?vue&type=style&index=0&id=2327ff34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327ff34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2327ff34')) {
      api.createRecord('2327ff34', component.options)
    } else {
      api.reload('2327ff34', component.options)
    }
    module.hot.accept("./Preference.vue?vue&type=template&id=2327ff34&scoped=true", function () {
      api.rerender('2327ff34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/Preference.vue"
export default component.exports